import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import axios from 'axios';
import { AiOutlineSearch } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';


const DormitoryReport = ({setLoading}) => {
  const [selectedSection, setSelectedSection] = useState('');
    const [response2, setResponse2] = useState({ message: '', status: 'success' });

  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [std, setStd] = useState([]);
  const [searchFilter, setSearchFilter] = useState('');
  const [dormitory, setDormitory] = useState([]);
const [selectedDormitoryId, setSelectedDormitoryId] = useState('');


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchHostel = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://api.kcian.in/fetch-dormitory');
      setDormitory(res.data);
 if (res.data.length > 0) {
      setSelectedDormitoryId(res.data[0].id.toString());
    }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

      useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
        fetchHostel();
      }, []);


        useEffect(() => {
          if (selectedClassId) {
            const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
            if (selectedClass && selectedClass.sections) {
              const sectionArray = selectedClass.sections
                .split(',')
                .map((s) => s.trim())
                .filter((s) => s !== '');
              setAvailableSections(sectionArray);
            } else {
              setAvailableSections([]);
            }
            setSelectedSection('');
          } else {
            setAvailableSections([]);
            setSelectedSection('');
          }
        }, [selectedClassId, classes]);


  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }

    setLoading(true);

    try {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-hostel-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setStd(data);

      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


const filteredStd = std.filter(cls => {
  const term = searchFilter.toLowerCase();
  const matchesSearch =
    cls.reg_no.toLowerCase().includes(term) ||
    cls.room_no.toLowerCase().includes(term) ||
    cls.room_type.toLowerCase().includes(term) ||
    cls.name.toLowerCase().includes(term);

  const matchesDormitory = selectedDormitoryId
    ? cls.dor_id?.toString() === selectedDormitoryId
    : true;

  return matchesSearch && matchesDormitory;
});



  return (
    <>
              <section className='py-4'>
            <div className='px-4'>
                    <HeadingArea message1='Hostel' message2='Hostel Report' />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>


 <div className='profile-card mt-4'>
            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
              <span className="profile-heading align-content-center">Student Hostel Report</span>


<div className='d-flex ms-auto gap-3'>
              <div className='profile-input-area ms-auto border-0'>
      <select
        className='profile-input border-bottom rounded-0'
        value={selectedDormitoryId}
        onChange={(e) => setSelectedDormitoryId(e.target.value)}
      >
        {dormitory.map((dorm) => (
          <option key={dorm.id} value={dorm.id}>
            {dorm.dormitory_name} ({dorm.type} Hostel)
          </option>
        ))}
      </select>
    </div>

              <div className='profile-input-area ms-auto border-0'>
      <input
        type='text'
        name='search'
        className='profile-input border-bottom rounded-0'
        placeholder='Search...'
        value={searchFilter}
        onChange={(e) => setSearchFilter(e.target.value)}
      />
    </div>
  </div>
</div>

              {/* <div className='profile-input-area ms-auto col-lg-3 border-0'>
                <input
                  type='text'
                  name='search'
                  className='profile-input border-bottom rounded-0'
                  placeholder='Search...'
                  value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                  // onChange={handleTextSearch}
                />
              </div>
            </div> */}

            <div className="table-responsive">
              <table className="w-100 text-center" >
                <thead className="account-thead rounded-4">
                  {/* <tr> */}
                  <th className='rounded-start-4'>S No</th>
                  <th>Class(Section)</th>
                  <th>Reg  No</th>
                  <th>Room No/ Type</th>
                  <th>Fee</th>
                  <th>Student Name</th>
                  <th>Mobile</th>
                  <th className='rounded-end-4'>Action</th>
                
                  {/* </tr> */}
                </thead>
                <tbody>
                  {filteredStd.length > 0 ? (
                    filteredStd.map((item, index) => (
                      <tr className='account-tr' key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.class_name} ({item.section})</td>
                        <td>{item.reg_no}</td>
                        <td>{item.room_no} ({item.room_type} Room)</td>
                        <td>₹ {item.bed_cost}</td>
                        <td>{item.name}</td>
                        <td>{item.mobile}</td>
                      
                        <td>
                          --
                         {/* <FaUserEdit className='emp-icon bg-primary' title='Assign Room' /> */}
                        </td>
                      </tr> 
                    ))
                  ) : (
                    <tr className='account-tr'>
                      <td colSpan="7">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>



</div>
</section>
    </>
  )
}

export default DormitoryReport
